var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drawer-container"},[_c('div',[_c('h3',{staticClass:"drawer-title"},[_vm._v("页面设置")]),_c('div',{staticClass:"drawer-item"},[_c('span',[_vm._v("开启多页面")]),_c('el-switch',{staticClass:"drawer-switch",model:{value:(_vm.tagsView),callback:function ($$v) {_vm.tagsView=$$v},expression:"tagsView"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }